import React from 'react'
import PropTypes from 'prop-types'
 
// Wait react-redux v8 for returning NavLink
import { Link } from 'react-router-dom'
import cn from 'classnames'

import './styles.scss'

const bc = 'nav'

const TopNav = ({ t, links, pathname, floatLeft, partialMatch }) => {
  return (
    <nav className={cn(bc, { [`${bc}__float-left`]: floatLeft })}>
      <ul className={`${bc}__list`}>
        {links.map(({ path, name }) => (
          <li className={`${bc}__item`} key={path}>
            <Link
              to={path}
              className={cn(`${bc}__link`, {
                active: partialMatch ? pathname.indexOf(path) !== -1 : pathname === path,
              })}
            >
              {t(name)}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}

TopNav.propTypes = {
  links: PropTypes.array.isRequired,
  floatLeft: PropTypes.bool,
  partialMatch: PropTypes.bool,
}

export default TopNav
